<template>
  <div class="filters-bar">
    <div class="filters-bar__filters">
      <div v-if="isPromotionFilter" class="form-select filters-bar__select">
        <label class="form-select-label promotion" v-if="showPromoLabels"><msg id="common.filters.promotion.type.text" /></label>
        <b-form-select
          v-model="form.category"
          :options="filteredCategories"
          id="category"
          @change="sendFilter"
          :aria-label="$msg('common.filters.category.label.aria')"
        >
        <template v-slot:first>
            <option :value="null">
                <msg id="common.filters.category.default-option.text" />
            </option>
        </template>
        </b-form-select>
      </div>
      <div class="form-select filters-bar__select">
        <label class="form-select-label range" v-if="showPromoLabels"><msg id="common.filters.promotion.range" /></label>
        <b-form-select
          v-model="form.family"
          :options="filteredFamilies"
          :disabled="isPromotionFilter && form.category === 'aftersales'"
          id="family"
          @change="sendFilter"
          :aria-label="$msg('common.filters.family.label.aria')"
        >
          <template v-slot:first>
            <option :value="null">
              <msg id="common.filters.family.default-option.text" />
            </option>
          </template>
        </b-form-select>
      </div>
      <div class="form-select filters-bar__select">
        <label class="form-select-label sort-by" v-if="showPromoLabels"><msg id="common.filters.promotion.vehicles" /></label>
        <b-form-select
          v-model="form.version"
          :options="filteredVersions"
          id="version"
          :disabled="form.family === null"
          @change="sendFilter"
          :aria-label="$msg('common.filters.model.label.aria')"
        >
          <template v-slot:first>
            <option :value="null">
              <msg id="common.filters.model.default-option.text" />
            </option>
          </template>
        </b-form-select>
      </div>
      <div v-if="!isPromotionFilter" class="form-select filters-bar__select">
        <b-form-select
          v-model="form.category"
          :options="filteredCategories"
          id="category"
          @change="sendFilter"
          :aria-label="$msg('common.filters.category.label.aria')"
        >
          <template v-slot:first>
            <option :value="null">
              <msg id="common.filters.category.default-option.text" />
            </option>
          </template>
        </b-form-select>
      </div>
      <div v-if="!isPromotionFilter" class="form-select filters-bar__select">
        <b-form-select
          v-model="form.subCategory"
          :options="filteredSubCategories"
          id="subCategory"
          :disabled="form.category === null"
          @change="sendFilter"
          :aria-label="$msg('common.filters.subcategory.label.aria')"
        >
          <template v-slot:first>
            <option :value="null">
              <msg id="common.filters.subcategory.default-option.text" />
            </option>
          </template>
        </b-form-select>
      </div>
      <div class="filters-bar__sorting">
        <label v-if="!showPromoLabels" class="custom-control-label" for="sort-by"
          ><msg id="common.filters.sort-by.text" />
        </label>
        <div class="form-select filters-bar__select">
          <label class="form-select-label sort-by" v-if="showPromoLabels"><msg id="common.filters.sort-by.text" /></label>
          <b-form-select
            v-model="form.sortBy"
            :options="optionsSortBy"
            id="sort-by"
            @change="sendFilter"
          >
          </b-form-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { prop, ascend, sort, isEmpty } from "ramda";
import router from '@wl-vue-utils/router.js'

export default {
  name: "FiltersBar",
  router: router,
  props: {
    filters: {
      type: Object,
      default: () => {},
      require: false,
    },
    showPromoLabels: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      selected: null,
      form: {
        family: null,
        version: null,
        category: null,
        subCategory: null,
        sortBy: null,
      },
    };
  },
  computed: {
    isPromotionFilter() {
      return this.filters.promotionFilter === true;
    },
    filteredFamilies() {
      let families = Object.keys(this.filters.families);
      let optionFamilies = families.map((family) => {
        return { value: family, text: family };
      });
      return optionFamilies;
    },
    filteredVersions() {
      if (this.form.family) {
        let versions = this.filters.families[this.form.family];
        if (!versions) return;

        let optionVersions = Object.keys(versions).map((key) => {
          return {
            value: key,
            text:
                versions[key] === "-"
                    ? this.$msg("common.vehicle.version.base.text")
                    : versions[key],
          };
        });
        return optionVersions;
      }
    },
    filteredCategories() {
      let categories = this.filters.categories;
      //if (!categories) return;

      let optionsCategory = categories.map((category) => {
        return { value: category.code, text: category.name };
      });
      return this._prepareOptions(optionsCategory, false);
    },
    filteredSubCategories() {
      if (this.form.category) {
        let categories = this.filters.categories;
        const selectedCategory = categories.find((category) => category && category.code === this.form.category);
        let optionsSubCategory = [];
        if(selectedCategory && selectedCategory.subCategories) {
          optionsSubCategory = selectedCategory.subCategories.map((subcategory) => {
              return {value: subcategory.code, text: subcategory.name};
          });

          return this._prepareOptions(optionsSubCategory, false);
        }
      }
    },
    optionsSortBy() {
      if (this.filters.sortBy && this.filters.sortBy.length > 0) {
          this.filters.sortBy.forEach(s => {
              s.text = this.$msg(s.text);
          });
          this.form.sortBy = this.filters.sortBy[0].value;
          return this.filters.sortBy;
      }

      this.form.sortBy = this.filters.promotionFilter ? "priority-asc" : "name-asc";
      return [
        {
          value: "name-asc",
          text: this.$msg("common.filters.sort-by.name.asc.text"),
        },
        {
          value: "price-asc",
          text: this.$msg("common.filters.sort-by.price.asc.text"),
        },
        {
          value: "price-desc",
          text: this.$msg("common.filters.sort-by.price.desc.text"),
        },
      ];
    },
  },
  methods: {
    _prepareOptions(listOfItems, addEmptyValue) {
      const byText = ascend(prop("text"));
      listOfItems = sort(byText, listOfItems || []);
      addEmptyValue && listOfItems.unshift(this.emptyOptionValue);
      return listOfItems;
    },
    sendFilter() {
      let filters = {}
      if(this.filters.promotionFilter) {
        filters = {
          mainCategory: !this.form.category
            ? ""
            : (category) => category === this.form.category,
          relatedVehicleFamilies: (!this.form.family || this.form.category === 'aftersales')
            ? ""
            : (family = '') => family.split(',').includes(this.form.family), // Temporary fix for lack of time
          relatedVehicleParentCodes: (!this.form.version || this.form.category === 'aftersales')
            ? ""
          : (version = '') => version.split(',').includes(this.form.version), // Temporary fix for lack of time
        };
      } else {
        filters = {
          relatedVehicleFamilies: !this.form.family
            ? ""
            : (family = '') => family.split(',').includes(this.form.family), // Temporary fix for lack of time
          relatedVehicleParentCodes: !this.form.version
            ? ""
            : (version = '') => version.split(',').includes(this.form.version), // Temporary fix for lack of time
          mainCategory: !this.form.category
            ? ""
            : (category) => category === this.form.category,
          subCategory: !this.form.subCategory
            ? ""
            : (subCategory) => subCategory === this.form.subCategory,
        };
      }

      // PIAGGIO-9572
      // Ottieni i parametri esistenti dall'URL
      console.log(`this.$route.fullPath = ${JSON.stringify(this.$route.query)}`);
      // Prendi tutti i parametri della query (inclusi UTM, ecc.)
      const fullUrl = this.$route.fullPath;
      const queryString = fullUrl.includes('?') ? fullUrl.split('?')[1] : '';
      const existingParams = new URLSearchParams(queryString);

      // Filtra i parametri che vuoi mantenere
      const existingParamsToKeep = new URLSearchParams();
      for (const [key, value] of existingParams.entries()) {
        if (!['family', 'version', 'category', 'subCategory'].includes(key)) {
          existingParamsToKeep.set(key, value); // anche se value è "", verrà mantenuto
        }
      }

      // Aggiungi nuovi parametri
      const newParams = this.generateQueryParams();
      if (typeof newParams === 'string') {
        new URLSearchParams(newParams).forEach((value, key) => {
          if (value !== null && value !== undefined) {
            existingParamsToKeep.set(key, value);
          }
        });
      } else if (typeof newParams === 'object') {
        Object.entries(newParams).forEach(([key, value]) => {
          if (value !== null && value !== undefined) {
            existingParamsToKeep.set(key, value);
          }
        });
      }

      console.log(`this.$route.fullPath = ${this.$route.fullPath} final query = ${existingParamsToKeep.toString()}`);
      // Aggiorna l'URL solo se effettivamente cambiato
      const newQuery = Object.fromEntries(existingParamsToKeep.entries());
      if (JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)) {
          this.$router.replace({ query: newQuery }).catch(err => {
              if (err.name !== "NavigationDuplicated") {
                  console.error(err);
              }
          });
      }

      /*
      console.log(`this.$route.fullPath = ${this.$route.params}`);
      const existingParams = new URLSearchParams(this.$route.params);
      let existingParamsToKeepMap = {};
      // Cancello dagli existent params quelli dei filtri che verranno calcolati dalla form
      for (const [key, value] of existingParams.entries()) {
        if(key !== 'family' && key !== 'version' && key !== 'category' && key !== 'subCategory') {
          existingParamsToKeepMap[key] = value;
        }
      }
      const existingParamsToKeep = new URLSearchParams(existingParamsToKeepMap);
      console.log(`this.$route.fullPath = ${this.$route.fullPath} existingParamsToKeep = ${existingParamsToKeep}`);
      // Aggiungi/aggiorna i nuovi parametri generati
      const newParams = this.generateQueryParams();
      const newParamsObj = new URLSearchParams(newParams);
      // Unisci i parametri nuovi con i nuovi
      for (const [key, value] of newParamsObj.entries()) {
        existingParamsToKeep.set(key, value); // Aggiorna o aggiungi il parametro
      }
      console.log(`this.$route.fullPath = ${this.$route.fullPath} existingParamsToKeep = ${existingParamsToKeep.toString()}`);
      // Aggiorna l'URL con la query string unita
      // window.history.pushState({}, '', `?${existingParamsToKeep.toString()}`);
      // this.$router.replace({ query: existingParamsToKeep });

      const newQuery = Object.fromEntries(existingParamsToKeep.entries());
      if (JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)) {
          this.$router.replace({ query: newQuery }).catch(err => {
              if (err.name !== "NavigationDuplicated") {
                  console.error(err);
              }
          });
      }
       */
      // this.$router.push({ query: {q: Object.fromEntries(existingParamsToKeep.entries()) }});

      this.$eventHub.emit("filtersBar:filter-by", filters);
      this.$eventHub.emit("filtersBar:sort-by", this.form.sortBy);
      console.log(`this.form.sortBy = ${this.form.sortBy}`);
    },
    generateQueryParams(){
      const queryParams = [];
      if(this.filters.promotionFilter && this.form.category === 'aftersales') {
        this.form.family = null;
        this.form.version = null;
      }
      if(this.form.family)
        queryParams.push(`family=${encodeURIComponent(this.form.family)}`);
      if(this.form.version)
        queryParams.push(`version=${encodeURIComponent(this.form.version)}`)
      if(this.form.category)
        queryParams.push(`category=${encodeURIComponent(this.form.category)}`)
      if (this.form.subCategory)
        queryParams.push(`subCategory=${encodeURIComponent(this.form.subCategory)}`)

      return queryParams.join('&');
    },
  },
  mounted() {
    // selectedOptions: family, version, mainCategory, subCategory
    //if(Object.keys(this.filters.selectedOptions).length !== 0) {
    if (!isEmpty(this.filters.selectedOptions)) {
      let doFilter = false;
      for(let [key, value] of Object.entries(this.filters.selectedOptions)){
        console.log("key: " + key + ", value: " + value);
        if (value) {
          this.form[key] = value;
          doFilter = true;
        }
      }
      this.$nextTick(() => {
        return this.sendFilter();
      });
    }
  },
  watch: {
    "form.family": function(newValue, oldValue) {
      if (newValue !== oldValue && oldValue !== null) {
        this.form.version = null;
      }
    },
    "form.category": function(newValue, oldValue) {
      if (newValue !== oldValue && oldValue !== null) {
        this.form.subCategory = null;
      }
    },
  },
};
</script>
